import { Tag } from 'src/app/people/models/tag';
import { PersonScenarioRequirement } from './personScenarioRequirement';

export class PersonCredentialScenario {
  public tags: Tag[];
  /** will only get set when called the getByPersonScenarioId API */
  public requirements: PersonScenarioRequirement[] = [];

  constructor(
    public id: string,
    public credentialScenarioDefinitionId: string,
    public status: PersonCredentialScenarioStatus,
    public name: string,
    /**number between 0 and 100*/
    public percentComplete: number,
    public credentialDefinitionId: string,
    public entityCredentialApplicationId: string,
    tags: Tag[]
  ) {
    this.tags = tags ? tags : [];
  }

  static parseWithRequirement(
    json: Partial<PersonCredentialScenario> & { requirements: PersonScenarioRequirement }
  ): PersonCredentialScenario {
    const model = PersonCredentialScenario.parse(json);
    model.requirements = json.requirements?.length
      ? json.requirements.map((requirement) => PersonScenarioRequirement.parse(requirement))
      : [];
    return model;
  }

  static parse(obj: Partial<PersonCredentialScenario>): PersonCredentialScenario {
    if (obj == null) return null;
    return new PersonCredentialScenario(
      obj.id,
      obj.credentialScenarioDefinitionId,
      obj.status,
      obj.name,
      obj.percentComplete,
      obj.credentialDefinitionId,
      obj.entityCredentialApplicationId,
      obj.tags
    );
  }

  public getStatusClass(): string {
    switch (this.status) {
      case PersonCredentialScenarioStatus.InProgress:
        return 'active';
      case PersonCredentialScenarioStatus.Completed:
        return 'accepted';
      case PersonCredentialScenarioStatus.Archived:
        return 'archived';
    }
  }

  public getStatusText(): string {
    switch (this.status) {
      case PersonCredentialScenarioStatus.InProgress:
        return 'In Progress';
      case PersonCredentialScenarioStatus.Completed:
        return 'Completed';
      case PersonCredentialScenarioStatus.Archived:
        return 'Archived';
    }
  }
}

export enum PersonCredentialScenarioStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
  Archived = 'Archived'
}
